// import { useState } from "react";
// import Swal from "sweetalert2";
// import api from "../api/axios";

// function AddCounters() {
//   const [counterName, setCounterName] = useState("");
//   const [prefix, setPrefix] = useState("");
//   const [isActive, setIsActive] = useState(true);

//   const saveService = async (e) => {
//     e.preventDefault();

//     const data = {
//       counterName,
//       prefix,
//       isActive,
//     };

//     try {
//       const response = await api.post("/Counter/AddCounter", data);

//       await Swal.fire({
//         icon: "success",
//         title: "Success",
//         text: response.data.message,
//       });

//       // Clear Form
//       setCounterName("");
//       setPrefix("");
//       setIsActive(true);
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: error.response?.data || "Something went wrong",
//       });
//     }
//   };

//   return (
//     <div className="card shadow">
//       <div className="card-header bg-primary text-white">
//         <h4 className="mb-0">Add Counter</h4>
//       </div>

//       <div className="card-body">
//         <form onSubmit={saveService}>
//           <div className="row">
//            <div className="col-md-6 mb-3">
//             <label className="form-label">Counter Name</label>

//             <input
//               type="text"
//               className="form-control"
//               value={counterName}
//               onChange={(e) => setCounterName(e.target.value)}
//               required
//             />
//           </div>

//             <div className="col-md-6 mb-3">
//             <label className="form-label">Prefix</label>

//             <input
//               type="text"
//               className="form-control"
//               value={prefix}
//               onChange={(e) => setPrefix(e.target.value)}
//               required
//             />
//           </div>

//          <div className="p-3 text-center col-md-12 col-12">
//             <input
//               type="checkbox"
//               className="form-check-input"
//               checked={isActive}
//               onChange={(e) => setIsActive(e.target.checked)}
//               id="isActive"
//             />

//             <label className="form-check-label" htmlFor="isActive">
//               Active
//             </label>
//           </div>
// <div className="col-md-12 mb-3 text-center">
//           <button type="submit" className="btn btn-success">
//             Save Counter
//           </button>
// </div>
// </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default AddCounters;


import { useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function AddCounters() {
  const [counterName, setCounterName] = useState("");
  const [prefix, setPrefix] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const saveService = async (e) => {
    e.preventDefault();

    if (loading) return;

    // Validation
    const errors = [];

    if (!counterName.trim()) errors.push("Counter Name");
    if (!prefix.trim()) errors.push("Prefix");

    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
       // title: "Validation",
        text: `${errors.join(", ")} is required.`,
      });
      return;
    }

    setLoading(true);

    const data = {
      counterName: counterName.trim(),
      prefix: prefix.trim().toUpperCase(),
      isActive,
    };

    try {
      const response = await api.post("/Counter/AddCounter", data);

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });

      // Clear Form
      setCounterName("");
      setPrefix("");
      setIsActive(true);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          error.response?.data ||
          "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Add Counter</h4>
        </div>

        <div className="card-body">
          <form onSubmit={saveService}>
            <div className="row">
              {/* Counter Name */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Counter Name <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Counter Name"
                  value={counterName}
                  onChange={(e) => setCounterName(e.target.value)}
                />
              </div>

              {/* Prefix */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Prefix <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Ex. A, B, C"
                  value={prefix}
                  maxLength={3}
                  onChange={(e) =>
                    setPrefix(e.target.value.toUpperCase())
                  }
                />
              </div>

              {/* Active */}
             <div className="p-3 text-center col-md-12 col-12">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isActive"
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                  />

                  <label
                    className="form-check-label"
                    htmlFor="isActive"
                  >
                    Active
                  </label>
              </div>

              {/* Buttons */}
              <div className="col-md-12 text-center">
                <button
                  type="submit"
                  className="btn btn-success me-2"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Save Counter"
                  )}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={loading}
                  onClick={() => {
                    setCounterName("");
                    setPrefix("");
                    setIsActive(true);
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddCounters;
